// Diccionario de traducciones — Español
const es = {
  comum: {
    salvar: 'Guardar',
    cancelar: 'Cancelar',
    excluir: 'Eliminar',
    deletar: 'Eliminar',
    editar: 'Editar',
    fechar: 'Cerrar',
    voltar: 'Volver',
    confirmar: 'Confirmar',
    carregando: 'Cargando...',
    salvando: 'Guardando...',
    enviando: 'Enviando...',
    processando: 'Procesando...',
    atualizar: 'Actualizar',
    buscar: 'Buscar',
    sim: 'Sí',
    nao: 'No',
    ok: 'OK',
    erro_generico: 'Ocurrió un error. Inténtalo de nuevo.',
    nenhum_resultado: 'No se encontraron resultados',
    obrigatorio: 'Campo obligatorio',
    opcional: 'opcional',
  },

  nav: {
    principal: 'Principal',
    dashboard: 'Panel',
    campanhas: 'Campañas',
    contatos: 'Contactos',
    envios: 'Envíos',
    metricas: 'Métricas',
    whatsapp: 'WhatsApp',
    configuracoes: 'Configuración',
    minha_empresa: 'Mi empresa',
    creditos: 'Créditos',
    pacotes: 'Paquetes',
    upgrade_plano: 'Mejorar plan',
    pack_ia: 'Pack IA adicional',
    ia_beta: 'IA (Beta)',
    secretaria_ia: 'Concierge IA',
    conversas: 'Conversaciones',
    configurar_ia: 'Configurar IA',
    ia_requer_plano: 'Requiere plan Pro o Pack IA. Haz clic para ver los paquetes.',
    administracao: 'Administración',
    painel_admin: 'Panel Admin',
    sair: 'Salir',
    painel: 'Panel',
    abrir_menu: 'Abrir menú',
    fechar_menu: 'Cerrar menú',
    idioma: 'Idioma',
  },

  login: {
    marca_sub: 'Tu Concierge IA en WhatsApp',
    nav_vantagens: 'Ventajas',
    nav_planos: 'Planes',
    nav_entrar: 'Entrar',
    hero_badge: 'Concierge IA que atiende tu WhatsApp 24h — sin vacaciones, sin baneos',
    hero_titulo_1: 'El paciente escribe a las 22h, un domingo, un feriado.',
    hero_titulo_destaque: 'Tu Concierge IA responde al instante',
    hero_sub: 'Cada paciente que espera respuesta agenda en la clínica de al lado. La Concierge IA de RIIA atiende, resuelve dudas, entiende el caso y agenda directo en tu agenda por WhatsApp — y además le recuerda antes de la consulta y recupera a quien desapareciads. Tú solo entras cuando la venta está lista.',
    hero_cta_gratis: 'Empezar gratis',
    hero_cta_planos: 'Ver planes',
    stat_entrega: 'Tasa de entrega',
    stat_respostas: 'Más respuestas',
    stat_negocios: 'Negocios atendidos',
    stat_gratis: 'Gratis para probar',
    stat_gratis_valor: '7 días',
    stat_freemium: 'Plan Freemium gratis',
    stat_freemium_valor: 'Gratis',
    form_titulo: 'Entrar al panel',
    form_sub: 'Accede a tu cuenta RIIA',
    form_ja_cliente: '¿Ya eres cliente? Ingresa con tu correo y contraseña.',
    form_email: 'Correo electrónico',
    form_senha: 'Contraseña',
    form_mostrar_senha: 'Mostrar contraseña',
    form_ocultar_senha: 'Ocultar contraseña',
    form_entrando: 'Entrando...',
    form_entrar: 'Entrar',
    form_sem_conta: '¿Aún no tienes cuenta?',
    form_ver_planos: 'Mira los planes',
    form_esqueci_senha: '¿Olvidaste tu contraseña?',
    recuperar_titulo: 'Recuperar contraseña',
    recuperar_descricao: 'Ingresa el email de tu cuenta. Te enviaremos un enlace para restablecer tu contraseña.',
    recuperar_enviar: 'Enviar enlace',
    recuperar_enviando: 'Enviando...',
    recuperar_sucesso: 'Si el email está registrado, recibirás un enlace de restablecimiento en breve.',
    recuperar_erro: 'Error al solicitar recuperación',
    erro_credenciais: 'Correo o contraseña inválidos',
    erro_conexao: 'Sin conexión con el servidor. Verifica tu internet.',
    erro_servidor: 'Servidor no disponible. Inténtalo de nuevo en unos instantes.',
    erro_generico: 'Error {status} al iniciar sesión',
    vantagens_titulo: 'Una concierge que no duerme, no olvida y no cuesta salario',
    vantagens_sub: 'Una recepcionista humana cuesta R$ 2.000+/mes y atiende 8h al día. La Concierge IA trabaja 24h, todos los días, sin vacaciones ni liquidación.',
    vantagens: {
      secretaria_titulo: 'Concierge IA 24/7',
      secretaria_texto: 'Responde a cada paciente en segundos, a cualquier hora. Resuelve dudas, entiende el caso por el embudo de tu negocio, agenda y avisa a tu equipo cuando el paciente está listo para cerrar.',
      ia_titulo: 'IA que humaniza',
      ia_texto: 'Cada mensaje es reescrito por IA para sonar natural y variar entre contactos — reduce el riesgo de bloqueo.',
      pacing_titulo: 'Ritmo humano',
      pacing_texto: 'Intervalos aleatorios entre mensajes y pausas por bloques. El envío respeta el ritmo de una persona real.',
      janela_titulo: 'Ventana de horario',
      janela_texto: 'Define un horario comercial para el envío. Pausa automática por la noche y retoma desde donde quedó al día siguiente.',
      canais_titulo: 'WhatsApp + Correo',
      canais_texto: 'Un solo panel, dos canales. Crea campañas multimedia (texto, imagen, video, audio, documento).',
      tempo_real_titulo: 'Sigue todo en tiempo real',
      tempo_real_texto: 'Panel de estado, envíos entregados, fallos y progreso de cada campaña — actualizado cada 15s.',
      import_titulo: 'Importación fácil',
      import_texto: 'Sube tu base por CSV o sincroniza directo del WhatsApp conectado. Grupos automáticos por tamaño.',
    },
    planos_titulo: 'Planes simples, sin letra pequeña',
    planos_sub: 'Empieza gratis. Mejora tu plan cuando lo necesites. Cancela cuando quieras.',
    plano_popular: 'Más popular',
    plano_gratis: 'Gratis',
    plano_para_sempre: 'para siempre',
    plano_sob_consulta: 'Bajo consulta',
    plano_personalizado: 'plan personalizado',
    planos: {
      freemium_descricao: 'Para conocer la plataforma',
      freemium_cta: 'Crear cuenta gratis',
      freemium_recursos: [
        '1 instancia de WhatsApp',
        '50 contactos',
        '100 envíos/mes',
        'Sin Concierge IA',
        'Soporte por correo',
      ],
      starter_descricao: 'Para pequeños negocios',
      starter_cta: 'Suscribir Starter',
      starter_recursos: [
        '1 instancia de WhatsApp',
        '1.000 contactos',
        '3.000 envíos/mes',
        'IA para variaciones de mensaje',
        'Créditos adicionales disponibles',
        'Soporte por correo',
      ],
      essencial_descricao: 'Para negocios en crecimiento',
      essencial_cta: 'Suscribir Esencial',
      essencial_recursos: [
        '2 instancias de WhatsApp',
        '2.000 contactos',
        '4.000 envíos/mes',
        'Concierge IA — 150 msgs/mes',
        'Créditos adicionales disponibles',
        'Soporte por correo',
      ],
      pro_descricao: 'Disparos + Concierge IA 24h',
      pro_cta: 'Suscribir Profesional',
      pro_recursos: [
        '3 instancias de WhatsApp',
        '3.000 contactos',
        '5.000 envíos/mes',
        'Concierge IA — 500 msgs/mes',
        'Créditos adicionales disponibles',
        'Soporte prioritario',
      ],
      enterprise_descricao: 'Para grandes operaciones',
      enterprise_cta: 'Hablar con ventas',
      enterprise_recursos: [
        'Instancias y volúmenes bajo demanda',
        'Concierge IA con cuota ampliada',
        'Múltiples usuarios y equipos',
        'Onboarding dedicado + SLA',
        'Gerente de cuenta exclusivo',
      ],
    },
    planos_rodape: '🔒 Pago seguro vía Stripe · Cancela cuando quieras · Sin permanencia',
    cta_titulo: '¿Cuántos pacientes vas a perder esta semana?',
    cta_sub: 'Activa tu Concierge IA hoy y responde a cada cliente en segundos. Empieza gratis, sin tarjeta.',
    cta_gratis: 'Empezar gratis',
    cta_vendas: 'Hablar con ventas',
    footer_direitos: '© {ano} RIIA · Todos los derechos reservados',
    footer_site: 'Sitio oficial',
    footer_suporte: 'Soporte',
    footer_assinar: 'Suscribir',
    whatsapp_vendas_msg: '¡Hola! Quiero saber más sobre RIIA.',
  },

  dashboard: {
    titulo: 'Panel',
    atualizado_as: 'Actualizado a las {hora}',
    atualizar: 'Actualizar',
    card_total: 'Total de campañas',
    card_finalizadas: 'Finalizadas',
    card_andamento: 'En curso',
    card_contatos: 'Contactos activos',
    ultimas_campanhas: 'Últimas campañas',
    status_campanhas: 'Estado de las campañas',
    pie_finalizadas: 'Finalizadas',
    pie_andamento: 'En curso',
    pie_erros: 'Errores',
    bar_finalizada: 'Finalizada',
    nenhuma_campanha: 'Aún no hay campañas',
  },

  fluxo: {
    titulo: 'Cómo empezar',
    etapas_concluidas: '{feitas} de {total} pasos completados',
    trilha_concierge: 'TU CONCIERGE — atiende, agenda y da seguimiento',
    trilha_campanhas: 'CAMPAÑAS — avisos y promociones masivas',
    c1_label: 'Activar la concierge',
    c1_desc: 'Habilita la atención automática en WhatsApp',
    c2_label: 'Decir quién es',
    c2_desc: 'Nombre, negocio y cómo debe atender',
    c3_label: 'Conectar la agenda',
    c3_desc: 'Para que reserve horarios reales en tu sistema',
    c4_label: 'Perfil de atención',
    c4_desc: 'Tono de voz, emoji y forma de trato',
    c5_label: 'Ajustar las antelaciones',
    c5_desc: 'Elegir cuándo avisar — por defecto ya avisa 1 día y 2 h antes',
    c6_label: 'Seguimiento posterior',
    c6_desc: 'Posvisita, reactivación o lista de espera',
    fechar_guia: 'Cerrar guía',
    fechar: 'Cerrar',
    step1_label: 'Conectar WhatsApp',
    step1_desc: 'Escanea el código QR para conectar tu número',
    step2_label: 'Sincronizar contactos',
    step2_desc: 'Importa los contactos de tu cuenta de WhatsApp',
    step3_label: 'Crear grupos',
    step3_desc: 'Organiza los contactos por segmento o campaña',
    step4_label: 'Crear campaña',
    step4_desc: 'Configura el mensaje, los intervalos y los destinatarios',
    step5_label: 'Iniciar envío',
    step5_desc: 'Activa el envío y sigue el progreso',
    opcional: 'opcional',
    concluido: '✓ Completado',
    fazer_agora: '→ Hacer ahora',
    pendente: 'Pendiente',
    tudo_pronto: '🎉 ¡Todo configurado! Tu sistema está listo para enviar campañas.',
  },

  whatsapp: {
    titulo: 'WhatsApp',
    subtitulo: 'Gestiona tus instancias y conecta números vía código QR.',
    atualizar_status: 'Actualizar estado',
    plano_info: '📱 Plan {plano} — {usadas} de {limite} instancia(s) usadas',
    limite_atingido_sufixo: ' · Límite alcanzado',
    fazer_upgrade: '⬆️ Mejorar plan',
    upgrade_msg: '¡Hola! Quiero mejorar mi plan RIIA para conectar más instancias de WhatsApp.',
    guia_titulo: '📋 Cómo conectar tu WhatsApp:',
    guia_desktop: 'Escritorio/portátil:',
    guia_desktop_texto: ' haz clic en código QR, abre WhatsApp en el celular → Dispositivos vinculados → Vincular dispositivo → escanea.',
    guia_celular: 'Celular/tablet:',
    guia_celular_texto: ' abre esta página en la computadora, genera el QR, haz clic en 📥 Descargar código QR, envíate la imagen a ti mismo (correo o WhatsApp) y escanéala desde otro dispositivo.',
    nova_instancia: 'Nueva instancia',
    nova_instancia_placeholder: 'Ej: chip-ventas-01',
    criando: 'Creando...',
    criar: 'Crear',
    limite_aviso: '⚠️ Límite de instancias alcanzado. Mejora tu plan para conectar más números.',
    qr_titulo: 'Escanea el código QR — {nome}',
    qr_passos: 'WhatsApp → Dispositivos vinculados → Vincular dispositivo',
    qr_celular: '📱 ¿Estás en el celular? Descarga el QR y ábrelo en otro dispositivo para escanear.',
    qr_baixar: '📥 Descargar código QR',
    qr_indisponivel: 'Código QR no disponible — espera o inténtalo de nuevo',
    qr_auto_atualiza: 'Se actualiza automáticamente cada 20s',
    fechar: 'Cerrar',
    col_instancia: 'Instancia',
    col_status: 'Estado',
    col_acoes: 'Acciones',
    status_conectado: 'Conectado',
    status_conectando: 'Conectando...',
    status_desconectado: 'Desconectado',
    status_nao_encontrada: 'No encontrada',
    status_desconhecido: 'Desconocido',
    btn_qrcode: '📷 Código QR',
    btn_sincronizar: 'Sincronizar contactos',
    btn_desconectar: 'Desconectar',
    btn_deletar: 'Eliminar',
    vazio: 'Aún no se ha creado ninguna instancia',
    toast_nome_obrigatorio: 'El nombre es obligatorio',
    toast_criada: '¡Instancia creada!',
    toast_erro_criar: 'Error al crear la instancia',
    toast_erro_qr: 'Error al obtener el código QR',
    toast_conectado: '¡WhatsApp conectado! 🎉',
    confirm_desconectar: '¿Desconectar "{nome}"?',
    toast_desconectada: 'Instancia desconectada',
    toast_erro_desconectar: 'Error al desconectar',
    confirm_deletar: '¿Eliminar la instancia "{nome}"?',
    toast_deletada: 'Instancia eliminada',
    toast_erro_deletar: 'Error al eliminar',
    toast_sincronizando: 'Sincronizando contactos...',
    toast_sincronizados: '¡{n} contactos sincronizados!',
    toast_erro_sincronizar: 'Error al sincronizar los contactos',
    popup_qr_titulo: '¡Instancia creada! 🎉',
    popup_qr_texto: 'Ahora conecta tu WhatsApp escaneando el código QR. Ese es el próximo paso para empezar a usar la instancia "{nome}".',
    popup_qr_botao: '📷 Conectar con código QR',
    popup_qr_depois: 'Después',
    popup_sync_titulo: '¡WhatsApp conectado! ✅',
    popup_sync_texto: 'Para empezar a enviar mensajes, sincroniza tus contactos de WhatsApp ahora. Podrás repetirlo cuando quieras.',
    popup_sync_botao: 'Sincronizar contactos',
    popup_sync_depois: 'Sincronizar después',
  },

  nova_campanha: {
    titulo: 'Nueva campaña',
    subtitulo: 'Configura el mensaje, los intervalos y los contactos antes de iniciar el envío.',
    step_configurar: 'Configurar campaña',
    step_contatos: 'Seleccionar contactos',
    nome_campanha_label: 'Nombre de la campaña',
    nome_campanha_placeholder: 'Ej: Promoción de abril',
    tipo_envio_label: 'Tipo de envío',
    tipo_whatsapp: '📲 WhatsApp',
    tipo_email: '📧 Email',
    addon_email_hint: '💡 ¿Quieres enviar por email también? Contrata el complemento por +R$10/mes en Configuración.',
    instancia_label: 'Instancia WhatsApp',
    instancia_placeholder: 'disparador01',
    instancia_nenhuma: 'Ninguna instancia registrada.',
    instancia_criar_link: 'Crea una aquí',
    midia_checkbox: '📎 Incluir multimedia (creativo)',
    midia_tipo_label: 'Tipo de multimedia',
    midia_tipo_image: '🖼️ Imagen',
    midia_tipo_video: '🎥 Video',
    midia_tipo_audio: '🎵 Audio',
    midia_tipo_document: '📄 Documento',
    midia_origem_upload: '📁 Archivo local',
    midia_origem_url: '🔗 URL externa',
    midia_upload_enviando: '⏳ Enviando...',
    midia_upload_enviado: '✅ {nome}',
    midia_upload_cta: '📁 Haz clic para seleccionar archivo',
    canva_divider: 'o crea en',
    canva_cta: 'Crear imagen en Canva',
    canva_aguardando: 'Esperando diseño en Canva...',
    canva_passos_1: 'Crea o edita tu diseño en Canva',
    canva_passos_2: 'Haz clic en Compartir → Descargar (PNG o JPG)',
    canva_passos_3: 'Vuelve aquí y selecciona el archivo descargado',
    canva_ja_baixei: 'Listo — seleccionar archivo',
    canva_cancelar: 'Cancelar',
    chatgpt_cta_imagem: 'Crear imagen con ChatGPT',
    chatgpt_cta_texto: 'ChatGPT',
    chatgpt_cta_texto_title: 'Abre ChatGPT en una ventana para crear/refinar el texto y pegarlo aquí',
    chatgpt_aguardando_imagem: 'Esperando imagen de ChatGPT...',
    chatgpt_aguardando_texto: 'ChatGPT abierto — copia el texto generado y pégalo abajo',
    chatgpt_passos_1_imagem: 'Pide a ChatGPT que cree la imagen',
    chatgpt_passos_2_imagem: 'Descarga la imagen generada',
    chatgpt_passos_3_imagem: 'Vuelve aquí y selecciona el archivo descargado',
    chatgpt_ja_baixei: 'Listo — seleccionar archivo',
    chatgpt_cancelar: 'Cancelar',
    midia_limite_hint: 'Tamaño máximo: {max} MB (límite de WhatsApp)',
    midia_url_label: 'URL de la multimedia',
    midia_url_placeholder: 'https://ejemplo.com/imagen.jpg',
    mensagem_label: 'Mensaje',
    gerar_copy_title_habilitado: 'Generar copy basado en la imagen',
    gerar_copy_title_desabilitado: 'Agrega una imagen arriba para habilitar',
    gerar_copy_gerando: 'Generando...',
    gerar_copy_btn: 'Generar copy con IA',
    mensagem_placeholder: '¡Hola {nome}, tenemos una condición especial para ti!',
    mensagem_hint: 'Usa {nome}, {telefone} para personalizar',
    ia_titulo: '✨ Generar variaciones del mensaje con IA',
    ia_ativo: 'La IA crea 5 versiones del mensaje manteniendo el contenido, temas, enlaces y CTA — solo varía el estilo. Reduce el riesgo de bloqueo.',
    ia_inativo: '⚠️ Sin variaciones: el mismo texto se enviará a todos. Se aplicará un intervalo mínimo de 6s y bloques de 40 contactos / 35s entre bloques para reducir el riesgo de bloqueo.',
    email_assunto_label: 'Asunto del email',
    email_assunto_tooltip: 'Línea de asunto que aparecerá en la bandeja de entrada del destinatario. Usa {nome} para personalizar.',
    email_assunto_tooltip_exemplo: '¡Hola {nome}, revisa nuestra oferta especial!',
    email_assunto_placeholder: 'Ej: {nome}, ¡tenemos una oferta exclusiva para ti!',
    email_fallback_label: 'Mensaje de texto (fallback)',
    email_fallback_tooltip: 'Versión en texto plano del email. Se muestra en clientes que no admiten HTML.',
    email_fallback_tooltip_exemplo: 'Hola {nome}, revisa nuestras ofertas en nuestro sitio.',
    email_fallback_placeholder: 'Hola {nome}, revisa nuestras ofertas...',
    email_corpo_label: 'Cuerpo del email',
    email_corpo_tooltip: 'Editor visual del cuerpo del email. Usa la barra de herramientas para dar formato al texto, insertar imágenes y enlaces. Alterna al modo HTML para edición avanzada.',
    email_corpo_tooltip_exemplo: 'Crea emails profesionales sin necesitar saber HTML',
    email_usar_template: '📄 Usar plantilla',
    email_hint: 'Usa {nome}, {telefone}, {email} para personalizar. Haz clic en 📁 en la barra para subir imágenes.',
    email_preview_label: '📧 Vista previa del email',
    email_preview_de: 'De:',
    email_preview_assunto: 'Asunto:',
    email_preview_sem_assunto: '(sin asunto)',
    intervalo_secao: 'Intervalo entre {canal}',
    intervalo_canal_emails: 'emails',
    intervalo_canal_mensagens: 'mensajes',
    intervalo_hint_opcional: '(opcional — deja en blanco para envío inmediato)',
    intervalo_min_label: 'Mínimo (seg)',
    intervalo_min_placeholder: 'Ej: 15',
    intervalo_descricao_com_valor: 'El intervalo varía aleatoriamente entre el mínimo indicado y {max} (mín + 15 s), simulando comportamiento humano.',
    intervalo_descricao_sem_valor: 'El intervalo varía aleatoriamente (mín + 15 s), simulando comportamiento humano.',
    blocos_secao: 'Envío por bloques',
    blocos_hint_opcional: '(opcional — pausa mayor cada N contactos)',
    blocos_tamanho_label: 'Tamaño del bloque',
    blocos_tamanho_placeholder: 'Ej: 20',
    blocos_intervalo_label: 'Intervalo entre bloques (seg)',
    blocos_intervalo_placeholder: 'Ej: 300 (5 min)',
    blocos_descricao: 'Cuando se definen, tras cada {n} contacto(s) el envío se pausa {x} segundo(s) antes de continuar. Rellena los dos campos para activar.',
    janela_secao: 'Ventana de envío',
    janela_hint_opcional: '(opcional — deja en blanco para enviar a cualquier hora)',
    janela_hora_inicio_label: 'Hora inicio',
    janela_hora_fim_label: 'Hora fin',
    janela_data_inicio_label: 'Fecha inicio',
    janela_dias_label: 'Días de la semana (haz clic para seleccionar)',
    dia_seg: 'Lun',
    dia_ter: 'Mar',
    dia_qua: 'Mié',
    dia_qui: 'Jue',
    dia_sex: 'Vie',
    dia_sab: 'Sáb',
    dia_dom: 'Dom',
    janela_descricao: 'El envío se pausa automáticamente al alcanzar la hora de fin y se reanuda al día siguiente desde donde se quedó. Solo envía en los días de la semana seleccionados.',
    btn_proximo: 'Siguiente — Seleccionar contactos →',
    grupos_label: 'Seleccionar por grupos',
    filtrar_instancia: 'Filtrar por instancia',
    filtrar_todas: 'Todas',
    btn_desmarcar_todos: 'Desmarcar todos',
    btn_selecionar_todos: 'Seleccionar todos',
    btn_desmarcar_instancia: 'Desmarcar {inst}',
    btn_selecionar_instancia: 'Seleccionar {inst}',
    btn_importar_csv: 'Importar CSV',
    btn_importando: 'Importando...',
    btn_contato_manual: '+ Contacto manual',
    contadores_filtrado: '{sel} de {total} ({inst})',
    contadores_geral: '{sel} de {total} seleccionados',
    csv_hint: '📄 El CSV debe tener columnas: nombre, teléfono, email (solo el teléfono es obligatorio)',
    form_contato_titulo: 'Agregar contacto manualmente',
    form_contato_nome: 'Nombre',
    form_contato_telefone: 'Teléfono',
    form_contato_email: 'Email',
    form_contato_salvar: 'Guardar y seleccionar',
    form_contato_salvando: 'Guardando...',
    form_contato_cancelar: 'Cancelar',
    importados_titulo: '📥 Contactos importados ahora ({n}) · {sel} seleccionado(s)',
    importados_desmarcar: 'Desmarcar todos',
    importados_selecionar: 'Seleccionar todos',
    importados_fechar: 'Cerrar lista de importados',
    busca_placeholder: 'Buscar por nombre o número...',
    vazio_nenhum_contato: 'Ningún contacto registrado. Importa un CSV o añade manualmente.',
    vazio_filtro_instancia: 'Ningún contacto en la instancia "{inst}"',
    vazio_busca: 'Ningún contacto encontrado',
    btn_voltar: '← Volver',
    btn_criar_campanha: '🚀 Crear campaña con {n} contacto(s)',
    btn_criando: 'Creando campaña...',
    toast_csv_importados: '¡{n} contactos importados!',
    toast_csv_erro: 'Error al importar CSV',
    toast_contato_telefone_obrigatorio: 'El teléfono es obligatorio',
    toast_contato_adicionado: '¡Contacto añadido!',
    toast_contato_erro: 'Error al añadir contacto',
    toast_sem_contatos: 'Selecciona al menos un contacto o grupo',
    toast_midia_url_vazia: 'Indica la URL de la multimedia o desmarca la opción',
    toast_email_sem_assunto: 'Indica el asunto del email',
    toast_sem_instancia: 'Selecciona una instancia de WhatsApp antes de enviar',
    toast_instancia_invalida: 'La instancia seleccionada no pertenece a tu cuenta',
    toast_campanha_criada: '¡Campaña creada! Confirma el inicio del envío en la lista.',
    toast_campanha_erro: 'Error al crear la campaña',
    toast_midia_enviada: '¡Archivo enviado!',
    toast_midia_erro: 'Error al enviar el archivo',
    toast_midia_grande: 'Archivo demasiado grande. El límite para {tipo} es {max} MB.',
    toast_copy_gerada: '¡Copy generada con IA! Edítala a tu gusto.',
    toast_copy_erro: 'Error al generar el copy. Verifica si la IA está configurada.',
    validacao_nome: 'El nombre de la campaña es obligatorio',
    validacao_mensagem: 'El mensaje es obligatorio',
    validacao_email_assunto: 'El asunto del email es obligatorio',
    validacao_email_corpo: 'Indica el cuerpo del email o el mensaje de texto',
    validacao_intervalo_minimo: 'El intervalo mínimo entre mensajes debe ser de al menos 15 segundos',
    filtro_business_secao: 'Filtro por tipo de cuenta',
    filtro_business_hint: 'seleccione qué cuentas recibirán esta campaña',
    filtro_business_label: 'Tipo de cuenta',
    filtro_business_todos: 'Todos los contactos',
    filtro_business_somente_business: 'Solo WhatsApp Business',
    filtro_business_somente_pessoal: 'Solo cuentas personales',
    filtro_business_descricao: 'Las cuentas Business pertenecen a empresas — menor riesgo de reportar spam. El tipo se detecta automáticamente al importar contactos.',
    filtro_tags_secao: 'Filtro por etiqueta',
    filtro_tags_todos: 'Todas las etiquetas',
    detectar_business_btn: 'Detectar Business',
    detectar_business_hint: 'Verifica en la Evolution API qué contactos tienen cuenta Business (solo los no verificados)',
    detectar_business_em_andamento: 'Detectando {processados}/{total}…',
    detectar_business_iniciado: 'Detección iniciada para {total} contactos — espera…',
    detectar_business_concluido: 'Detección finalizada: {atualizados}/{total} contactos actualizados',
    detectar_business_nada_fazer: 'Todos los contactos ya han sido verificados',
    detectar_business_erro: 'Fallo en la detección: {erro}',
    validacao_blocos_sem_ia: 'Sin variaciones de IA: configura el envío por bloques (tamaño e intervalo) para reducir el riesgo de bloqueo',
  },

  campanhas: {
    titulo: 'Campañas',
    subtitulo: 'Crea, monitorea y reenvía campañas con control de pausa, intervalo y bloques.',
    btn_nova: 'Nueva campaña',
    col_nome: 'Nombre',
    col_status: 'Estado',
    col_horario: 'Horario',
    col_intervalo: 'Intervalo',
    col_criada_em: 'Creada el',
    col_acoes: 'Acciones',
    badge_nova: 'Nueva',
    status_finalizado: 'Finalizado',
    status_pendente: 'Pendiente',
    status_processando: 'Procesando',
    status_pausada: 'Pausada',
    status_sem_instancia: 'Sin instancia',
    status_aguardando_horario: 'Fuera de horario',
    status_limite_diario: 'Límite del día',
    status_bloqueio_detectado: 'Verificar chip',
    status_plano_vencido: 'Plan vencido',
    status_erro: 'Error',
    tooltip_limite_diario: 'Se alcanzó el límite diario de envíos de esta instancia. La campaña se reanudará automáticamente mañana.',
    tooltip_bloqueio: 'Detectamos 3 o más fallos seguidos — el chip puede tener restricciones de WhatsApp. Verifica el WhatsApp conectado y haz clic en Reactivar cuando todo esté bien.',
    tooltip_sem_instancia: 'El WhatsApp de esta campaña está desconectado. Reconecta el chip en Menú → WhatsApp.',
    tooltip_aguardando_horario: 'La campaña está fuera de la ventana de horario configurada. Se reanudará automáticamente en el próximo horario de inicio.',
    intervalo_imediato: 'Inmediato',
    btn_iniciar_envio: 'Iniciar envío',
    btn_pausar: 'Pausar',
    btn_retomar: 'Reanudar',
    btn_reativar: 'Reactivar',
    btn_reenviar: 'Reenviar',
    btn_deletar: 'Eliminar',
    vazio: 'Aún no se ha creado ninguna campaña',
    detalhe_titulo: '{nome}',
    detalhe_status: 'Estado',
    detalhe_tipo: 'Tipo',
    detalhe_instancia: 'Instancia',
    detalhe_intervalo: 'Intervalo',
    detalhe_bloco: 'Bloque',
    detalhe_bloco_valor: '{tamanho} contactos · pausa {intervalo}s',
    detalhe_horario: 'Horario',
    detalhe_progresso: 'Progreso',
    detalhe_progresso_valor: '{n} enviados',
    detalhe_mensagem: 'Mensaje',
    detalhe_contatos: 'Contactos vinculados ({n})',
    reenvio_titulo: 'Reenviar — {nome}',
    reenvio_hint: 'Deja en blanco para reenviar a los mismos contactos de la campaña original, o selecciona una nueva lista abajo.',
    reenvio_instancia_label: '📲 Instancia WhatsApp',
    reenvio_grupos_label: 'Seleccionar grupos',
    reenvio_grupos_selecionados: '· {n} seleccionado(s)',
    reenvio_desmarcar_todos: 'Desmarcar todos',
    reenvio_selecionar_todos: 'Seleccionar todos',
    reenvio_importar_csv: 'Importar nueva lista (CSV)',
    reenvio_importando: 'Importando...',
    reenvio_contadores: '{sel} / {total} seleccionados',
    reenvio_importados_titulo: '📥 Importados ahora ({n}) · {sel} seleccionado(s)',
    reenvio_selecionar_contatos: 'Seleccionar contactos',
    reenvio_busca_placeholder: 'Buscar por nombre o teléfono...',
    reenvio_vazio: 'Ningún contacto encontrado',
    reenvio_cancelar: 'Cancelar',
    reenvio_btn: '🚀 Reenviar campaña',
    confirmar_inicio_titulo: 'Confirmar inicio del envío',
    confirmar_inicio_descricao: 'Estás a punto de iniciar el envío de la campaña',
    confirmar_aviso_titulo: '⚠️ Aviso importante',
    confirmar_aviso_texto: 'La práctica de envío masivo por WhatsApp puede causar restricciones, bloqueo temporal o baneo permanente del número utilizado. Usa intervalos entre mensajes, ventanas de horario razonables y envía solo a contactos que esperan tener noticias tuyas. Tú eres el único responsable del uso de la herramienta y de las consecuencias del envío.',
    confirmar_aceitar_termos: 'He leído y acepto los términos. Entiendo que el envío masivo puede generar restricciones o el baneo de mi WhatsApp y asumo la responsabilidad por el envío.',
    confirmar_cancelar: 'Cancelar',
    confirmar_iniciando: 'Iniciando...',
    confirmar_btn_iniciar: '🚀 Iniciar envío',
    toast_pausada: 'Campaña pausada',
    toast_erro_pausar: 'Error al pausar',
    toast_retomada: 'Campaña reanudada',
    toast_erro_retomar: 'Error al reanudar',
    toast_reativada: '¡Campaña reactivada! Se procesará en instantes.',
    toast_erro_reativar: 'Error al reactivar',
    confirm_deletar: '¿Eliminar la campaña "{nome}"?',
    toast_deletada: 'Campaña eliminada',
    toast_erro_deletar: 'Error al eliminar',
    toast_erro_detalhe: 'Error al cargar los detalles',
    toast_reenviada: '¡Campaña reenviada!',
    toast_erro_reenviar: 'Error al reenviar la campaña',
    toast_csv_importados: '¡{n} contactos importados!',
    toast_csv_erro: 'Error al importar CSV',
    toast_iniciado: '¡Envío iniciado!',
    toast_erro_iniciar: 'Error al iniciar el envío',
  },

  contatos: {
    titulo: 'Contactos',
    subtitulo_filtrado: '({filtrado} de {total})',
    subtitulo: '({total})',
    pagina_sub: 'Administra contactos y grupos organizados por instancia de WhatsApp.',
    btn_remover_dup: 'Eliminar duplicados',
    btn_limpar_invalidos: 'Limpiar inválidos',
    btn_excluir_sel: 'Eliminar seleccionados ({n})',
    btn_novo: 'Nuevo contacto',
    form_titulo: 'Nuevo contacto',
    col_nome: 'Nombre',
    col_telefone: 'Teléfono',
    col_email: 'Correo',
    col_instancia: 'Instancia',
    col_ia: 'Concierge IA',
    col_cadastrado: 'Registrado el',
    col_acoes: 'Acciones',
    ia_ativar_title: 'Activar Concierge IA para este contacto',
    ia_desativar_title: 'Desactivar Concierge IA para este contacto',
    toast_ia_ativada: 'Concierge IA activada para el contacto',
    toast_ia_desativada: 'Concierge IA desactivada para el contacto',
    toast_erro_ia: 'Error al cambiar la Concierge IA del contacto',
    todas_instancias: 'Todas las instancias',
    placeholder_telefone: '5561999999999',
    btn_salvar: 'Guardar contacto',
    toast_telefone_obrigatorio: 'Teléfono es obligatorio',
    toast_adicionado: '¡Contacto agregado!',
    toast_erro_adicionar: 'Error al agregar contacto',
    toast_atualizado: '¡Contacto actualizado!',
    toast_erro_atualizar: 'Error al actualizar contacto',
    confirm_remover: '¿Eliminar contacto "{nome}"?',
    toast_removido: '¡Contacto eliminado!',
    toast_erro_remover: 'Error al eliminar contacto',
    confirm_limpar_lids: '¿Eliminar contactos con teléfono inválido (LIDs de WhatsApp y números fuera del estándar)? Quedarán ocultos pero conservados en el historial.',
    toast_lids_removidos: '{n} contacto(s) inválido(s) eliminado(s)',
    toast_nenhum_invalido: 'Ningún contacto inválido encontrado',
    toast_erro_limpar: 'Error al limpiar contactos',
    confirm_dedup: '¿Eliminar entradas duplicadas de un mismo número de teléfono? Se conservará el registro más completo.',
    toast_dup_removidos: '{n} duplicado(s) eliminado(s)',
    toast_nenhum_dup: 'Ningún duplicado encontrado',
    toast_erro_dedup: 'Error al eliminar duplicados',
    toast_csv_nenhum: 'No se importó ningún contacto. Verifica que la hoja tenga una columna de teléfono.',
    toast_csv_reativados: '{n} contacto(s) estaban desactivados y fueron reactivados por este archivo.',
    toast_csv_timeout: 'La importación tardó más de lo esperado y el navegador dejó de esperar. Puede que los contactos se hayan guardado igual — actualiza la lista antes de reintentar.',
    toast_csv_rede: 'No pude contactar al servidor para importar. Revisa tu conexión e inténtalo de nuevo.',
    import_instancia_label: 'Importar en:',
    import_instancia_nenhuma: 'Sin instancia',
    import_instancia_hint: 'Opcional — organiza los contactos importados bajo una instancia. No cambia desde qué número dispara la campaña.',
    toast_csv_importados_instancia: '{n} contacto(s) importado(s) en {instancia}',
    toast_csv_truncados: '{n} contacto(s) NO se importaron: tu plan permite {limite}. Mejora el plan o compra créditos.',
    toast_csv_sem_telefone: '{n} fila(s) no tenían teléfono y fueron ignoradas.',
    confirm_excluir_massa: '¿Eliminar {n} contacto(s) seleccionado(s)?',
    toast_excluidos: '¡{n} contacto(s) eliminado(s)!',
    toast_erro_excluir_massa: 'Error al eliminar {n} contacto(s)',
    vazio_instancia: 'Ningún contacto para "{inst}". Sincroniza desde el panel de WhatsApp.',
    vazio: 'Aún no hay contactos registrados',
    grupos_titulo: 'Grupos',
    grupos_gerar_auto: 'Generar automático',
    grupos_com_sel: '+ Grupo con {n} seleccionado(s)',
    grupos_novo: 'Nuevo grupo',
    grupos_auto_titulo: '⚡ Generar grupos automáticos',
    grupos_auto_sub: 'Divide los contactos en grupos de N cada uno, respetando la instancia seleccionada.',
    grupos_instancia_label: 'Instancia',
    grupos_instancia_todas: 'Todas las instancias ({n} contactos)',
    grupos_tamanho_label: 'Contactos por grupo',
    grupos_prefixo_label: 'Prefijo del nombre',
    grupos_resultado: 'Resultado: ~{grupos} grupos de {tam} contactos ({total} total)',
    grupos_gerando: 'Generando...',
    grupos_gerar_btn: 'Generar {n} grupos',
    grupos_vazio_instancia: 'Ningún grupo para la instancia "{inst}".',
    grupos_vazio: 'Ningún grupo creado. Crea uno para organizar tus contactos.',
    modal_grupo_titulo: 'Nuevo grupo',
    modal_nome_label: 'Nombre del grupo',
    modal_nome_placeholder: 'Ej: Pacientes de control',
    modal_descricao_label: 'Descripción',
    modal_descricao_placeholder: 'Ej: campaña marzo',
    modal_instancia_label: 'Instancia',
    modal_instancia_todas: '— todas —',
    modal_contatos_label: 'Contactos ({n} seleccionados)',
    modal_buscar: 'Buscar...',
    modal_criar_btn: 'Crear grupo ({n})',
    modal_criar_btn_sem: 'Crear grupo',
    modal_nome_obrigatorio: 'El nombre del grupo es obligatorio',
    modal_criado: '¡Grupo creado! {n} contacto(s) agregado(s).',
    modal_criado_sem: '¡Grupo creado!',
    modal_erro_criar: 'Error al crear grupo',
    grupo_salvar: 'Guardar ({n})',
    grupo_salvando: 'Guardando...',
    grupo_atualizado: '¡Grupo actualizado!',
    grupo_erro_salvar: 'Error al guardar grupo',
    confirm_excluir_grupo: '¿Eliminar grupo "{nome}"? Los contactos no serán eliminados.',
    toast_grupo_excluido: '¡Grupo eliminado!',
    toast_erro_excluir_grupo: 'Error al eliminar grupo',
    buscar_contato: 'Buscar contacto...',
    nenhum_contato: 'Ningún contacto',
    selecionar_todos: 'Seleccionar todos los visibles',
    col_tags: 'Etiquetas',
    tags_placeholder: 'vip, control, paciente',
    tags_hint: 'Separa por coma. Ej: vip, control',
    todas_tags: 'Todas las etiquetas',
    toast_atualizado_tags: '¡Etiquetas actualizadas!',
  },

  grupos: {
    titulo: 'Grupos',
    subtitulo: '({n})',
    pagina_sub: 'Organiza contactos en grupos manuales o generados automáticamente.',
    btn_gerar_auto: 'Generar automático',
    btn_novo: 'Nuevo grupo',
    aviso_ban: '⚠️ Enviar a muchos grupos simultáneos puede resultar en ban o restricción por WhatsApp. Úsalo con moderación.',
    auto_titulo: '⚡ Generar grupos automáticos',
    auto_sub: 'Divide todos los {n} contactos en grupos de N contactos cada uno.',
    tamanho_label: 'Contactos por grupo',
    prefixo_label: 'Prefijo del nombre',
    resultado: 'Resultado: ~{grupos} grupos de {tam} contactos',
    gerando: 'Generando...',
    gerar_btn: 'Generar {n} grupos',
    form_titulo: 'Nuevo grupo manual',
    form_nome_label: 'Nombre del grupo',
    form_nome_placeholder: 'Ej: Pacientes de control',
    form_instancia_label: 'Instancia',
    form_instancia_todas: 'Todas',
    form_descricao_label: 'Descripción',
    form_descricao_placeholder: 'Opcional',
    form_contatos_label: 'Contactos ({sel} seleccionados de {total})',
    form_limpar: 'Limpiar selección',
    form_buscar: 'Buscar por nombre o teléfono...',
    form_nenhum_contato: 'Ningún contacto importado',
    form_nenhum_instancia: 'Ningún contacto en esta instancia',
    form_criando: 'Creando...',
    form_criar: 'Crear grupo',
    col_nome: 'Nombre',
    col_descricao: 'Descripción',
    col_contatos: 'Contactos',
    col_criado: 'Creado el',
    badge_contatos: '{n} contactos',
    gerenciar_label: 'Gestionar contactos — {nome}',
    gerenciar_sel: '{n} seleccionados',
    buscar_contato: 'Buscar contacto...',
    nenhum_contato: 'Ningún contacto',
    salvando: 'Guardando...',
    salvar: 'Guardar',
    vazio: 'Aún no se ha creado ningún grupo',
    toast_nome_obrigatorio: 'El nombre es obligatorio',
    toast_criado: '¡Grupo creado!',
    toast_erro_criar: 'Error al crear grupo',
    toast_gerados: '¡{n} grupos generados!',
    toast_erro_gerar: 'Error al generar grupos',
    confirm_deletar: '¿Eliminar grupo "{nome}"?',
    toast_deletado: 'Grupo eliminado',
    toast_erro_deletar: 'Error al eliminar grupo',
    toast_atualizados: 'Contactos actualizados',
    toast_erro_salvar: 'Error al guardar',
  },

  envios: {
    titulo: 'Envíos',
    atualizado_as: 'Actualizado a las {hora}',
    btn_atualizar: 'Actualizar',
    btn_exportar_csv: 'Exportar CSV',
    selecionar_campanha: 'Seleccionar campaña',
    selecione_opcao: 'Selecciona una campaña...',
    contagem: '{n} envío(s) encontrado(s)',
    col_contato: 'Contacto',
    col_telefone: 'Teléfono',
    col_status: 'Estado',
    col_mensagem: 'Mensaje enviado',
    col_data: 'Fecha',
    vazio: 'Ningún envío encontrado para esta campaña',
  },

  metricas: {
    titulo: 'Métricas de campaña',
    subtitulo: 'Tasa de entrega, distribución por hora y principales errores por campaña.',
    selecionar_campanha: 'Seleccionar campaña',
    selecione_opcao: 'Seleccione una campaña...',
    btn_atualizar: 'Actualizar',
    carregando: 'Cargando métricas...',
    sem_dados: 'Aún no hay datos para esta campaña.',
    sem_erros: 'Sin errores registrados.',
    kpi_total: 'Total',
    kpi_enviados: 'Enviados',
    kpi_erros: 'Errores',
    kpi_pendentes: 'Pendientes',
    kpi_taxa: 'Tasa de entrega',
    kpi_tentativas: 'Promedio de intentos',
    grafico_status: 'Distribución por estado',
    grafico_hora: 'Envíos por hora del día',
    top_erros_titulo: 'Errores principales',
    col_erro: 'Mensaje de error',
    col_ocorrencias: 'Ocurrencias',
    status_enviado: 'Enviado',
    status_erro: 'Error',
    status_pendente: 'Pendiente',
  },

  configuracoes: {
    titulo: 'Configuración',
    subtitulo: 'Gestiona acceso, integraciones y envíos por email.',
    salvando: 'Guardando...',
    btn_salvar: 'Guardar',
    sec_senha: 'Cambiar contraseña',
    label_senha_atual: 'Contraseña actual',
    label_nova_senha: 'Nueva contraseña',
    label_confirmar_senha: 'Confirmar nueva contraseña',
    btn_alterar_senha: 'Cambiar contraseña',
    toast_campos_obrigatorios: 'Completa todos los campos',
    toast_senhas_nao_conferem: 'Las contraseñas no coinciden',
    toast_senha_curta: 'La nueva contraseña debe tener al menos 6 caracteres',
    toast_senha_alterada: '¡Contraseña cambiada con éxito!',
    toast_erro_senha: 'Error al cambiar contraseña',
    sec_email: 'Cambiar email',
    email_atual_label: 'Email actual:',
    label_novo_email: 'Nuevo email',
    label_confirmar_senha_email: 'Confirma tu contraseña',
    warn_email: '⚠️ Después de cambiar el email, deberás iniciar sesión nuevamente.',
    btn_alterar_email: 'Cambiar email',
    toast_email_alterado: '¡Email cambiado! Inicia sesión nuevamente.',
    toast_erro_email: 'Error al cambiar email',
    sec_push: 'Notificaciones push',
    push_sem_suporte: 'Tu navegador no admite notificaciones push. Usa Chrome, Edge o Firefox.',
    push_bloqueado: '⚠️ Has bloqueado las notificaciones para este sitio. Reactívalas en la configuración del navegador (haz clic en el candado junto a la URL) y recarga la página.',
    push_descricao: 'Recibe alertas en tu dispositivo cuando finalice una campaña o cuando una instancia de WhatsApp se desconecte — funciona incluso con el panel cerrado.',
    push_ativo: '✅ Notificaciones activadas en este dispositivo.',
    btn_teste_push: 'Enviar prueba',
    btn_desativar_push: 'Desactivar',
    btn_ativar_push: 'Activar notificaciones en este dispositivo',
    btn_ativando_push: 'Activando...',
    toast_push_ativado: '¡Notificaciones activadas! 🔔',
    toast_push_desativado: 'Notificaciones desactivadas',
    toast_push_erro_desativar: 'Error al desactivar',
    toast_push_teste: '¡Prueba enviada! Revisa la notificación.',
    toast_push_erro_teste: 'Error al enviar prueba',
    sec_whatsapp: '📲 Evolution API (WhatsApp)',
    label_url_api: 'URL de la API',
    label_api_key: 'API Key',
    toast_config_salvas: '¡Configuración guardada!',
    toast_erro_salvar: 'Error al guardar',
    sec_openai: '🤖 OpenAI',
    openai_warn: '⚠️ Necesario para variaciones de mensaje con IA. Sin la clave, se usan variaciones locales.',
    sec_blacklist: 'Blacklist — contactos que solicitaron baja',
    blacklist_todas: 'Todos ({n})',
    blacklist_vazio: '✅ Ningún contacto en la blacklist',
    blacklist_vazio_instancia: '✅ Ningún contacto en la blacklist de la instancia "{instancia}".',
    blacklist_bloqueado_em: 'Bloqueado el {data}',
    toast_blacklist_removido: 'Contacto eliminado de la blacklist',
    toast_blacklist_erro: 'Error al eliminar de la blacklist',
    sec_cap: 'Warm-up y límite diario por instancia',
    cap_col_instancia: 'Instancia',
    cap_col_empresa: 'Empresa',
    cap_col_dias: 'Días de uso',
    cap_col_cap_auto: 'Límite automático',
    cap_col_override: 'Override manual',
    cap_col_enviados: 'Enviados hoy',
    cap_aquecendo: 'Día {dia} (calentando)',
    cap_dias: '{n} días',
    cap_por_dia: '{n}/día',
    cap_placeholder: 'Auto',
    toast_cap_atualizado: 'Límite actualizado',
    toast_cap_erro: 'Error al guardar límite',
    sec_garantia: 'Garantía de 7 días',
    garantia_reembolso_solicitado: '✅ Tu solicitud de reembolso fue recibida. Nos pondremos en contacto en un plazo de 24 horas para procesar la cancelación.',
    garantia_texto: 'Estás dentro del plazo de garantía de 7 días. Si no estás satisfecho, puedes solicitar el reembolso completo y cancelaremos tu cuenta sin preguntas.',
    garantia_prazo: 'Plazo restante: {dias} día(s).',
    btn_solicitar_reembolso: '↩ Solicitar reembolso',
    btn_enviando: 'Enviando...',
    toast_reembolso_enviado: '¡Solicitud enviada! Nos pondremos en contacto en un plazo de 24h.',
    toast_reembolso_erro: 'Error al solicitar reembolso. Inténtalo de nuevo.',
    confirm_reembolso: '¿Estás seguro de que deseas solicitar el reembolso? Tu cuenta será cancelada después del procesamiento.',
    sec_smtp: '📧 Envíos por Email (SMTP)',
    smtp_ativo: '✅ Addon de email activo — configura tu servidor SMTP a continuación',
    smtp_where: '📖 ¿Dónde encontrar los datos SMTP? Accede a la configuración de tu proveedor de email:',
    label_smtp_host: 'Host SMTP',
    label_smtp_porta: 'Puerto',
    label_smtp_from: 'Email remitente',
    label_smtp_user: 'Usuario',
    label_smtp_pass: 'Contraseña',
    btn_salvar_smtp: 'Guardar configuración de email',
    addon_titulo: 'Agrega el módulo de envíos por email a tu plan',
    addon_descricao: 'Envía campañas por email además de WhatsApp. Configura tu propio servidor SMTP.',
    addon_periodo: '/mes',
    btn_contratar_addon: '💳 Contratar addon de email',
    btn_processando: 'Procesando...',
    addon_rodape: 'Pago seguro vía Stripe · Activación inmediata tras confirmación',
    toast_addon_ativado: '¡Addon de email activado con éxito! 🎉',
    toast_addon_erro: 'Error al activar el addon. Contacta al soporte.',
    toast_addon_contratar_erro: 'Error al procesar. Inténtalo de nuevo.',
  },

  redefinir: {
    titulo: 'Restablecer contraseña',
    subtitulo: 'Elige una nueva contraseña para tu cuenta',
    label_nova_senha: 'Nueva contraseña',
    label_confirmar: 'Confirmar contraseña',
    btn_salvar: 'Restablecer contraseña',
    btn_salvando: 'Guardando...',
    sucesso: '¡Contraseña restablecida con éxito!',
    sucesso_titulo: '¡Todo listo!',
    sucesso_redirect: 'Redirigiendo al inicio de sesión...',
    erro_token: 'Token de restablecimiento inválido',
    erro_curta: 'La contraseña debe tener al menos 6 caracteres',
    erro_diferente: 'Las contraseñas no coinciden',
    erro_generico: 'Error al restablecer la contraseña. El enlace puede haber expirado.',
    erro_sem_token: 'Enlace de restablecimiento inválido o ausente. Solicita uno nuevo.',
    voltar_login: 'Volver al inicio de sesión',
  },

  creditos: {
    titulo: 'Créditos Adicionales',
    subtitulo: 'Complementa los límites de tu plan sin necesidad de hacer upgrade.',
    carregando: 'Cargando...',
    freemium_titulo: 'El plan Freemium no incluye créditos adicionales',
    freemium_texto: 'Los créditos adicionales están disponibles para suscriptores Starter, Pro y Enterprise. Actualiza tu plan para desbloquear esta funcionalidad.',
    ver_planos: 'Ver planes',
    por_pack: '/pack',
    btn_comprar: 'Comprar — R$ {preco}',
    rodape: '🔒 Pago seguro vía Stripe o PIX · Créditos válidos hasta fin de mes · Sin renovación automática',
    modal_titulo: 'Finalizar compra',
    escolha_metodo: '¿Cómo deseas pagar?',
    pix_titulo: 'PIX',
    pix_sub: 'Instantáneo, sin cargos adicionales',
    cartao_titulo: 'Tarjeta de crédito',
    cartao_sub: 'Débito o crédito (Stripe)',
    voltar: 'Volver',
    label_cartao: 'Datos de la tarjeta',
    btn_pagar: 'Pagar R$ {preco},00',
    btn_processando: 'Procesando...',
    modal_rodape: '🔒 Pago seguro · Sin renovación automática',
    pix_gerando: 'Generando QR Code...',
    pix_instrucao: 'Escanea el QR Code en tu app bancaria o copia el código PIX.',
    pix_aguardando: 'Esperando confirmación del pago...',
    pix_confirmado: '¡Pago confirmado! Los créditos estarán disponibles en breve.',
    copiar: 'Copiar',
    copiado: '¡Copiado!',
    toast_pack_adquirido: '¡Pack "{nome}" adquirido! Los créditos ya están disponibles.',
    toast_pix_pago: '¡Pago PIX confirmado! Créditos añadidos.',
    toast_erro_iniciar: 'Error al iniciar el pago',
    pack_disparos_nome: 'Pack Disparos',
    pack_disparos_descricao: '+1.000 envíos extras',
    pack_disparos_item1: '1.000 envíos adicionales',
    pack_disparos_item2: 'Se acumulan con los envíos del plan',
    pack_disparos_item3: 'Se usan tras alcanzar el límite mensual',
    pack_disparos_item4: 'Válidos hasta fin del mes en curso',
    pack_ia_nome: 'Pack IA',
    pack_ia_descricao: '+100 mensajes de Concierge IA',
    pack_ia_item1: '100 msgs Concierge IA extras',
    pack_ia_item2: 'Se acumulan con los del plan',
    pack_ia_item3: 'Se usan tras alcanzar el límite mensual',
    pack_ia_item4: 'Válidos hasta fin del mes en curso',
  },

  admin: {
    titulo: 'Panel Admin',
    subtitulo: 'Gestiona clientes, planes y cuentas de prueba.',
    carregando: 'Cargando...',
    btn_criar_usuario: '+ Crear usuario',
    stat_total_clientes: 'Total de clientes',
    stat_clientes_ativos: 'Clientes activos',
    stat_aguardando: 'Esperando pago',
    stat_total_disparos: 'Total de envíos',
    stat_total_campanhas: 'Total de campañas',
    stat_total_contatos: 'Total de contactos',
    status_ativo: 'Activo',
    status_pendente: 'Pendiente',
    status_suspenso: 'Suspendido',
    col_empresa: 'Empresa',
    col_email: 'Email',
    col_telefone: 'Teléfono',
    col_plano: 'Plan',
    col_status: 'Estado',
    col_campanhas: 'Campañas',
    col_contatos: 'Contactos',
    col_cadastro: 'Registro',
    col_ultimo_acesso: 'Último acceso',
    col_vencimento: 'Vencimiento',
    col_acoes: 'Acciones',
    clientes: 'Clientes ({n})',
    btn_gerenciar: 'Gestionar',
    btn_ativar: 'Activar',
    btn_reativar: 'Reactivar',
    btn_suspender: 'Suspender',
    btn_deletar: 'Eliminar',
    vazio: 'Ningún cliente registrado aún',
    modal_criar_titulo: 'Crear usuario',
    label_nome_empresa: 'Nombre de la empresa',
    label_nome_responsavel: 'Nombre del responsable',
    label_email: 'Email',
    label_segmento: 'Segmento',
    placeholder_nome_empresa: 'Ej: Tienda de Juan',
    placeholder_nome_responsavel: 'Ej: Juan García',
    placeholder_email: 'juan@email.com',
    placeholder_segmento: 'Ej: E-commerce, Salud...',
    label_plano: 'Plan',
    label_dias_validade: 'Días de vigencia',
    btn_criar: '✓ Crear usuario',
    btn_criando: 'Creando...',
    btn_cancelar: 'Cancelar',
    btn_fechar: 'Cerrar',
    resultado_titulo: '✅ ¡Cuenta creada con éxito!',
    resultado_email: 'Email',
    resultado_senha: 'Contraseña temporal',
    resultado_plano: 'Plan',
    resultado_vencimento: 'Vencimiento',
    resultado_aviso: '⚠️ Guarda las credenciales ahora — la contraseña no se mostrará de nuevo.',
    btn_copiar_creds: '📋 Copiar credenciales',
    toast_copiado: '¡Credenciales copiadas!',
    toast_criado: '¡Cuenta creada con éxito!',
    toast_erro_criar: 'Error al crear cuenta',
    toast_campos: 'Completa todos los campos',
    modal_gerenciar: 'Gestionar — {nome}',
    label_periodo: 'Período',
    periodo_mensal: 'Mensual',
    periodo_anual: 'Anual',
    periodo_teste: 'Prueba',
    stat_envios: 'Envíos',
    stat_email_admin: 'Email admin',
    btn_salvar_plano: 'Guardar plan',
    sec_estender: '📅 Extender vigencia',
    btn_aplicar: 'Aplicar',
    btn_salvando: 'Guardando...',
    vencimento_atual: 'Vencimiento actual:',
    sec_senha: '🔑 Restablecer contraseña',
    senha_resetada: '✅ ¡Contraseña restablecida!',
    btn_copiar: '📋 Copiar credenciales',
    btn_gerar_senha: '🔑 Generar nueva contraseña aleatoria',
    btn_gerando: 'Generando...',
    senha_aviso: 'La contraseña actual se invalida de inmediato.',
    sec_overrides: '⚙️ Override de límites individuales',
    override_aviso: 'Deja en blanco para usar el límite del plan.',
    label_instancias: 'Instancias',
    label_disparos_mes: 'Envíos/mes',
    label_ia_mes: 'Msgs IA/mes',
    placeholder_padrao: 'Predeterminado del plan',
    btn_salvar_overrides: 'Guardar overrides',
    sec_creditos: '🎁 Conceder créditos adicionales',
    creditos_aviso: 'Los créditos expiran al fin del mes en curso.',
    tipo_disparos: 'Envíos',
    tipo_ia: 'Mensajes IA',
    placeholder_qtd: 'Cant',
    placeholder_desc_credito: 'Descripción (opcional)',
    btn_conceder: 'Conceder créditos',
    toast_overrides: 'Overrides guardados',
    toast_overrides_erro: 'Error al guardar overrides',
    toast_creditos: '¡{n} créditos de {tipo} concedidos!',
    toast_creditos_qtd: 'Indica la cantidad',
    toast_creditos_erro: 'Error al conceder créditos',
    toast_ativado: '¡Tenant activado!',
    toast_ativar_erro: 'Error al activar',
    confirm_suspender: '¿Suspender "{nome}"?',
    toast_suspenso: 'Tenant suspendido',
    toast_suspender_erro: 'Error al suspender',
    toast_plano_atualizado: '¡Plan actualizado!',
    toast_plano_erro: 'Error al cambiar plan',
    confirm_resetar: '¿Generar una nueva contraseña aleatoria para este cliente?',
    toast_resetar_erro: 'Error al restablecer contraseña',
    toast_estendido: 'Vigencia extendida hasta {data}',
    toast_estender_erro: 'Error al extender vigencia',
    confirm_deletar: '¿Eliminar permanentemente "{nome}"? Todos los datos se perderán.',
    toast_deletado: 'Tenant eliminado',
    toast_deletar_erro: 'Error al eliminar',
    auditoria_titulo: 'Auditoría — campañas con instancia incorrecta',
    auditoria_verificar: 'Verificar',
    auditoria_atualizar: 'Actualizar',
    auditoria_vazio_info: 'Haz clic en "Verificar" para listar campañas que se enviaron con la instancia de otro tenant.',
    auditoria_ok: '✅ Ninguna campaña con instancia incorrecta encontrada.',
    col_campanha: 'Campaña',
    col_empresa_dona: 'Empresa propietaria',
    col_instancia_errada: 'Instancia actual (incorrecta)',
    col_dono_instancia: 'Dueño de la instancia actual',
    col_enviados: 'Enviados',
    col_nova_instancia: 'Nueva instancia',
    sem_instancia_disponivel: 'Sin instancia disponible',
    selecionar_placeholder: 'Seleccionar...',
    btn_reatribuir: 'Reasignar',
    toast_reatribuido: 'Instancia reasignada a "{nome}"',
    toast_reatribuir_erro: 'Error al reasignar',
    toast_select_instancia: 'Selecciona una instancia',
    toast_erro_auditoria: 'Error al cargar auditoría',
    toast_erro_dashboard: 'Error al cargar panel admin',
    skeleton_empresa: 'Empresa',
    skeleton_cadastro: 'Registro',
    skeleton_acoes: 'Acciones',
  },

  configuracao_ia: {
    titulo: 'Concierge IA',
    subtitulo: 'Configura tu asistente virtual para responder automáticamente en WhatsApp.',
    label_instancia: 'Instancia',
    sem_instancia: 'Aún no tienes instancias de WhatsApp. Crea una en la pestaña WhatsApp primero.',
    quota_sem_plano: '⚠️ El plan {plano} no incluye la Concierge IA',
    quota_upgrade: 'Actualiza al plan Pro (500 msgs/mes) o Enterprise (2.000 msgs/mes) para activarla.',
    uso_mes: 'Uso este mes ({mes})',
    uso_mensagens: '{usado} / {limite} mensajes',
    toggle_titulo: 'Respuestas automáticas',
    toggle_ativo: 'IA activa — respondiendo mensajes recibidos',
    toggle_inativo: 'IA desactivada',
    sec_secretaria: 'Concierge IA',
    sec_secretaria_desc: 'Responde las preguntas a continuación y la IA creará una asistente personalizada para tu negocio.',
    configurada: 'Concierge configurada',
    btn_reconfigurar: 'Reconfigurar',
    step1: '1. ¿Cuál es el tipo de tu negocio?',
    step2: '2. ¿Cómo debe comunicarse tu concierge?',
    step3: '3. Configura tu concierge',
    label_nome_secretaria: '¿Cómo se llama tu secretaria?',
    placeholder_nome_secretaria: 'Ej: Julia, Sofía, Ana',
    hint_nome_secretaria: 'La IA usará este nombre para presentarse en las conversaciones.',
    label_objetivo_conversa: '¿Cuál es el objetivo principal de tu concierge?',
    obj_agendar_nome: 'Agendar consultas / visitas',
    obj_agendar_desc: 'Recopila datos y agenda por WhatsApp',
    obj_qualificar_nome: 'Entender el caso',
    obj_qualificar_desc: 'Recopila el interés y lo pasa a la recepción',
    obj_vender_nome: 'Cerrar ventas',
    obj_vender_desc: 'Conduce al cliente hacia la decisión de compra',
    obj_informar_nome: 'Responder dudas',
    obj_informar_desc: 'Responde sobre productos, servicios y precios',
    label_descricao_negocio: 'Describe tu negocio en 1 o 2 frases',
    placeholder_descricao_negocio: 'Ej: Clínica odontológica especializada en ortodoncia y estética dental para adultos y niños.',
    label_publico_alvo: '¿Quién es tu cliente típico?',
    placeholder_publico_alvo: 'Ej: Adultos de 25 a 50 años que buscan tratamiento estético y han tenido malas experiencias con otros dentistas.',
    label_dados_coletar: '¿Qué debe saber tu concierge del paciente antes de derivarlo?',
    hint_dados_coletar: 'El embudo de calificación se construirá con estos datos — márcalos en el orden en que deseas preguntar.',
    dado_nome: 'Nombre completo',
    dado_telefone: 'Teléfono de contacto',
    dado_email: 'E-mail',
    dado_cidade: 'Ciudad / Barrio',
    dado_servico: 'Servicio o producto de interés',
    dado_orcamento: 'Presupuesto disponible',
    dado_data: 'Fecha / horario preferido',
    dado_empresa: 'Empresa / NIT/CNPJ',
    dado_quantidade: 'Número de personas o alumnos',
    label_objetivo: '¿Cuál es el objetivo de tu negocio?',
    label_servicos: '¿Qué servicios o productos ofreces?',
    label_horario: 'Horario de atención',
    label_contato: '¿Cómo los clientes agendan o se contactan?',
    label_pagamento: 'Formas de pago aceptadas',
    label_profissional: 'Profesional o especialista destacado',
    label_diferencial: '¿Cuál es el mayor diferencial de tu negocio?',
    label_restricoes: 'Restricciones o información importante',
    label_localizacao: 'Ciudad y barrio',
    label_cursos: '¿Ofreces cursos o capacitaciones?',
    opcional: '(opcional)',
    placeholder_objetivo: 'Ej: Somos una clínica odontológica especializada en...',
    placeholder_servicos: 'Ej: Brackets, blanqueamiento, implantes, limpieza...',
    placeholder_horario: 'Ej: Lun-Vie 8h-18h, Sáb 8h-12h',
    placeholder_profissional: 'Ej: Dra. Ana, 15 años de experiencia en...',
    placeholder_diferencial: 'Lo que te diferencia de la competencia...',
    placeholder_restricoes: 'Ej: Solo particular, sin cobertura médica. Estacionamiento gratuito...',
    placeholder_localizacao: 'Ej: Buenos Aires, Palermo',
    placeholder_cursos: 'Describe los cursos...',
    btn_gerar: '✨ Configurar Concierge con IA',
    btn_gerando: 'Generando configuración...',
    toast_ia_ativada: 'IA activada',
    toast_ia_desativada: 'IA desactivada',
    toast_configurada: '¡Concierge configurada con éxito!',
    toast_erro_gerar: 'Error al generar configuración',
    toast_salvo: 'Configuración guardada',
    conflito_titulo: 'Partes de esta configuración pueden entrar en conflicto con las reglas fijas del sistema:',
    conflito_confirm: 'Esta configuración puede entrar en conflicto con las Reglas Absolutas del sistema, que tienen prioridad:',
    conflito_confirm_pergunta: '¿Guardar de todos modos?',
    toast_erro_salvar: 'Error al guardar',
    toast_erro_diagnostico: 'Error en el diagnóstico',
    toast_erro_testar: 'Error al probar IA',
    erro_tipo_negocio: 'Selecciona el tipo de negocio',
    erro_estilo: 'Selecciona el estilo de comunicación de tu concierge',
    erro_objetivo: 'Selecciona el objetivo principal de la conversación',
    erro_descricao: 'Describe tu negocio (campo obligatorio)',
    avancado_titulo: '⚙️ Modo avanzado (edición manual)',
    avancado_bloqueado_titulo: 'Modo avanzado liberado bajo solicitud',
    avancado_bloqueado_desc: 'La edición manual de persona, base de conocimiento y embudo requiere conocimientos de prompt engineering. Para evitar configuraciones que perjudiquen el desempeño de tu secretaria, este modo se libera bajo solicitud al soporte — nuestro equipo valida tu configuración antes de liberarla.',
    avancado_btn_solicitar: 'Solicitar acceso al modo avanzado',
    avancado_email_assunto: 'Solicitud de acceso — Modo avanzado IA',
    avancado_email_corpo: 'Hola, quisiera liberar el modo avanzado de configuración de la Concierge IA en mi cuenta. Email de la cuenta: ',
    label_persona: 'Persona / instrucciones de tono',
    label_conhecimento: 'Base de conocimiento — lo que tu IA sabe del negocio',
    label_funil: 'Embudo de calificación — lo que tu IA necesita descubrir',
    label_delay: 'Delay antes de responder ({s}s)',
    delay_recomendado: 'Recomendado: 8s (general), 12–15s (salud/jurídico), 0s para respuesta inmediata.',
    label_pausa_horas: 'Pausa al tomar control (horas)',
    btn_salvar_avancado: 'Guardar configuración técnica',
    btn_salvando: 'Guardando...',
    btn_diagnostico: 'Diagnóstico',
    diag_titulo: 'Diagnóstico',
    diag_ok: 'Todo bien — la IA debería estar respondiendo.',
    diag_ultimas: 'Últimos {n} mensajes registrados',
    teste_titulo: 'Probar IA',
    teste_desc: 'Simula una pregunta usando la persona y base de conocimiento actuales (sin enviar por WhatsApp).',
    placeholder_teste: 'Ej: ¿Cuál es el horario de atención?',
    btn_testar: 'Probar',
    btn_testando: 'Probando...',
    resposta_vazia: '(respuesta vacía)',
    tipo_saude_nome: 'Salud & Clínicas',
    tipo_saude_desc: 'Médicos, dentistas, clínicas',
    tipo_beleza_nome: 'Belleza & Estética',
    tipo_beleza_desc: 'Salón, barbería, estética',
    tipo_alimentacao_nome: 'Alimentación',
    tipo_alimentacao_desc: 'Restaurante, delivery, café',
    tipo_educacao_nome: 'Educación & Cursos',
    tipo_educacao_desc: 'Escuela, cursos, capacitaciones',
    tipo_comercio_nome: 'Comercio',
    tipo_comercio_desc: 'Tienda, retail, e-commerce',
    tipo_servicos_nome: 'Servicios',
    tipo_servicos_desc: 'Mantenimiento, consultoría, reformas',
    tipo_imoveis_nome: 'Inmuebles',
    tipo_imoveis_desc: 'Inmobiliaria, alquiler, venta',
    tipo_juridico_nome: 'Jurídico & Financiero',
    tipo_juridico_desc: 'Abogacía, contabilidad, seguros',
    tipo_outro_nome: 'Otro',
    tipo_outro_desc: 'Mi negocio no está en la lista',
    estilo_humana_nome: 'Humana',
    estilo_humana_desc: 'Empática, cercana, usa el nombre del cliente',
    estilo_direta_nome: 'Directa',
    estilo_direta_desc: 'Va al grano, respuestas cortas y objetivas',
    estilo_persuasiva_nome: 'Persuasiva',
    estilo_persuasiva_desc: 'Enfocada en convertir, destaca beneficios y crea urgencia',
    estilo_profissional_nome: 'Profesional',
    estilo_profissional_desc: 'Tono corporativo, lenguaje estructurado y formal',
    estilo_descontraida_nome: 'Desenfadada',
    estilo_descontraida_desc: 'Casual, amigable, usa emojis con naturalidad',
    label_tratamento: 'Cómo hablar con el cliente',
    tratamento_voce_nome: 'Tú',
    tratamento_voce_desc: 'Trato directo y cercano',
    tratamento_senhor_nome: 'Usted',
    tratamento_senhor_desc: 'Trato formal y respetuoso',
    opcao_contato_whatsapp: 'WhatsApp',
    opcao_contato_telefone: 'Teléfono',
    opcao_contato_site: 'Sitio web',
    opcao_contato_presencial: 'Presencialmente',
    opcao_contato_email: 'E-mail',
    opcao_contato_app: 'App',
    opcao_pag_dinheiro: 'Efectivo',
    opcao_pag_credito: 'Tarjeta de crédito',
    opcao_pag_debito: 'Tarjeta de débito',
    opcao_pag_pix: 'PIX',
    opcao_pag_boleto: 'Boleto',
    opcao_pag_convenio: 'Plan/Convenio',
    opcao_pag_parcelamento: 'Cuotas propias',
    notif_titulo: 'Notificación automática de paciente',
    notif_desc: 'Cuando la IA recopile los datos configurados abajo, envía automáticamente un mensaje al número indicado (ej: línea de citas, secretaría, ventas).',
    notif_ativar: 'Activar notificación automática',
    notif_telefone: 'Número que recibirá las notificaciones',
    notif_telefone_ph: 'Ej: 5491155555555',
    notif_telefone_ajuda: 'Incluya código de país y área. Solo números.',
    notif_campos: 'Datos que deben recopilarse antes de notificar',
    notif_campo_nome: 'Nombre completo',
    notif_campo_cpf: 'Documento (CPF/DNI)',
    notif_campo_email: 'E-mail',
    notif_campo_contato: 'Teléfono de contacto',
    notif_campo_data: 'Fecha de cita',
    notif_campo_horario: 'Horario de cita',
    btn_salvar_notif: 'Guardar notificación',
    agenda_titulo: 'Integración con Agenda',
    agenda_desc: 'Cuando la IA confirme una cita con el cliente (fecha y hora acordadas), crea automáticamente el evento en tu calendario.',
    agenda_provedor: 'Proveedor de calendario',
    agenda_prov_nenhum: 'Ninguno',
    agenda_selecione_provedor: 'Selecciona un proveedor para configurar la integración.',
    agenda_google_desc: 'Autoriza el acceso a tu cuenta Google para crear eventos automáticamente. Se requiere GOOGLE_CLIENT_ID configurado en el servidor.',
    agenda_google_autorizar: 'Autorizar con Google',
    agenda_google_conectado: '¡Google Calendar conectado con éxito!',
    agenda_google_desconectado: 'Google Calendar desconectado',
    agenda_google_conectado_badge: 'Cuenta Google conectada',
    agenda_google_desconectar: 'Desconectar',
    agenda_google_erro_auth: 'Error al iniciar autorización Google',
    agenda_google_calendar_id: 'ID del calendario',
    agenda_google_calendar_id_ajuda: 'Usa "primary" para el calendario principal o el ID de un calendario específico.',
    agenda_icloud_desc: 'Ingresa tus credenciales Apple para crear eventos vía CalDAV. Por seguridad, Apple exige una contraseña específica de app — tu contraseña normal no funciona aquí.',
    agenda_icloud_passos_titulo: 'Cómo conectar (toma 1 minuto):',
    agenda_icloud_passo1: 'Accede a appleid.apple.com e inicia sesión con tu Apple ID.',
    agenda_icloud_passo2: 'En "Seguridad", abre "Contraseñas de apps específicas" y haz clic en "Generar una contraseña". Ponle el nombre "RIIA" y copia la contraseña mostrada.',
    agenda_icloud_passo3: 'Pega tu Apple ID y la contraseña generada en los campos de abajo. Deja el campo de la URL en blanco.',
    agenda_icloud_passo4: 'Haz clic en "Probar conexión" — la URL de tu calendario se detecta automáticamente.',
    agenda_icloud_username: 'Apple ID (correo)',
    agenda_icloud_password: 'Contraseña específica de app',
    agenda_icloud_password_ph: 'Generada en appleid.apple.com',
    agenda_icloud_url: 'URL del calendario CalDAV (opcional)',
    agenda_icloud_url_ajuda: 'Déjalo en blanco — la URL se detecta automáticamente al probar la conexión.',
    agenda_icloud_url_auto: 'Detectada automáticamente',
    agenda_dias: 'Días disponibles para citas',
    agenda_dom: 'Dom', agenda_seg: 'Lun', agenda_ter: 'Mar',
    agenda_qua: 'Mié', agenda_qui: 'Jue', agenda_sex: 'Vie', agenda_sab: 'Sáb',
    agenda_hora_inicio: 'Hora de inicio',
    agenda_hora_fim: 'Hora de fin',
    agenda_duracao: 'Duración predeterminada',
    agenda_timezone: 'Zona horaria',
    agenda_ativar: 'Activar creación automática de eventos',
    agenda_confirmacao_ativar: 'Esta instancia envía confirmaciones y recordatorios de la agenda',
    agenda_confirmacao_ajuda: 'Desmarca en instancias secundarias que comparten la misma agenda (ej.: el mismo Simples Dental) para evitar mensajes duplicados al paciente. Mantenla marcada en solo una instancia por agenda.',
    credencial_revelar: 'Mostrar valor guardado',
    credencial_revelando: 'Mostrando...',
    credencial_ocultar: 'Ocultar',
    credencial_copiar: 'Copiar',
    credencial_copiada: 'Credencial copiada',
    credencial_copiar_falhou: 'No se pudo copiar',
    credencial_vazia: '(nunca configurado)',
    credencial_aviso: 'Valor confidencial. Este acceso queda registrado en la auditoría.',
    lembretes_titulo: 'Recordatorios automáticos',
    lembretes_ajuda: 'Define con cuánta antelación avisar al cliente. Cada línea genera un mensaje. Sin ninguna línea, siguen valiendo los recordatorios por defecto (1 día y 2 horas antes).',
    lembretes_add: 'Añadir recordatorio',
    lembretes_antes: 'antes',
    lembretes_dias: 'días',
    lembretes_horas: 'horas',
    lembretes_confirma: 'Pedir confirmación de asistencia',
    lembretes_confirma_ajuda: 'Marca las antelaciones en las que la IA debe preguntar "¿puedo confirmar tu asistencia?". Las demás son solo aviso. En Google Calendar e iCloud la respuesta queda registrada aquí, porque esos calendarios no tienen campo de confirmación.',
    lembretes_janela: 'Ventana de envío — ningún recordatorio sale fuera de este horario, en la zona horaria de la agenda.',
    lembretes_conflito: 'Esta instancia está marcada para NO enviar confirmaciones/recordatorios (opción de arriba). Con antelaciones configuradas aquí, el envío antiguo también deja de cubrir esta instancia — resultado: no sale ningún recordatorio. Marque la opción de arriba, o configure las antelaciones en la otra instancia que comparte esta agenda.',
    lembretes_diag: 'Diagnóstico de recordatorios',
    lembretes_diag_rodando: 'Verificando…',
    diag_timeout: 'El diagnóstico tardó demasiado en responder. Es tiempo, no necesariamente un fallo: su sistema puede estar lento ahora. Inténtelo de nuevo en unos minutos.',
    diag_rede: 'No fue posible contactar al servidor para ejecutar el diagnóstico. Revise su conexión e inténtelo de nuevo.',
    lembretes_diag_erro: 'Error al ejecutar el diagnóstico de recordatorios',
    reativacao_titulo: "Reactivar clientes que dejaron de volver",
    reativacao_desc: "Una vez por hora, RIIA lee la agenda de tu sistema, encuentra a quien no aparece hace tiempo y envía UN mensaje. Quien responde cae en la concierge, que agenda el turno. Desactivado por defecto: no se envía nada hasta que marques esta casilla.",
    reativacao_dias_label: "Sin volver hace",
    reativacao_dias_hint: "días o más (de 7 a 60 — el tope viene del alcance de la agenda de tu sistema)",
    reativacao_texto_label: "Mensaje (opcional)",
    reativacao_texto_ph: "¡Hola {nome}! Hace un tiempo que no te vemos 😊 ¿Quieres que te busque un turno esta semana?",
    reativacao_texto_hint: 'Usa {nome} para el primer nombre del cliente. Escribe UN MENSAJE POR LÍNEA para variarlos — en cada envío sale uno, y nunca dos iguales seguidos. En blanco, usamos 5 variaciones por defecto.',
    reativacao_diag: "Diagnóstico de la reactivación",
    reativacao_diag_rodando: "Comprobando...",
    reativacao_diag_erro: "No se pudo ejecutar el diagnóstico de reactivación",
    reativacao_previa: "Quién saldría en este ciclo:",
    pos_atend_titulo: 'Agradecer después de la cita',
    pos_atend_desc: 'Después de la visita, la concierge envía un mensaje de agradecimiento — y pide una valoración si quieres. Las respuestas llegan a esta conversación como siempre.',
    pos_atend_horas_label: 'Enviar',
    pos_atend_horas_hint: 'horas después del inicio de la cita (1 a 48)',
    pos_atend_texto_label: 'Mensaje (opcional)',
    pos_atend_texto_ph: '¡Hola {nome}! Paso para agradecer tu visita {quando} 😊',
    pos_atend_texto_hint: 'Usa {nome} para el primer nombre del cliente y {quando} para el día de la visita (se convierte en “de hoy”, “de ayer” o el día de la semana — el mensaje suele salir al día siguiente). Escribe UN MENSAJE POR LÍNEA para variarlos — en cada envío sale uno, y nunca dos iguales seguidos. En blanco, usamos 5 variaciones por defecto.',
    pos_atend_avaliacao: 'Pedir valoración en el mismo mensaje',
    pos_atend_link_ph: 'https://g.page/tu-empresa/review',
    pos_atend_link_hint: 'Enlace de valoración (Google, Instagram…). Sin enlace, pedimos la opinión aquí por WhatsApp.',
    pos_atend_diag: 'Diagnóstico de posvisita',
    pos_atend_diag_rodando: 'Verificando…',
    pos_atend_diag_erro: 'No se pudo ejecutar el diagnóstico',
    pos_atend_previa: 'Quién saldría en este ciclo:',
    pos_atend_com_avaliacao: 'con solicitud de reseña',
    pos_atend_avaliacao_hint: 'La solicitud de reseña se envía solo en el PRIMER mensaje de posatención de cada cliente. A quien ya la recibió se le sigue agradeciendo, pero sin la solicitud ni el enlace.',
    espera_titulo: 'Avisar cuando se libere un hueco (lista de espera)',
    espera_desc: 'Cuando el cliente pide un día que está lleno, la concierge guarda la solicitud. Si se libera un hueco ese día, lo ofrece — sin prometer, porque otra persona puede tomarlo antes.',
    espera_texto_label: 'Mensaje (opcional)',
    espera_texto_ph: '¡Hola {nome}! Se liberó un hueco {quando} 😊 ¿Quieres que lo reserve?',
    espera_texto_hint: 'Usa {nome} para el primer nombre y {quando} para el hueco que se liberó.',
    espera_diag: 'Diagnóstico de la lista de espera',
    espera_diag_rodando: 'Verificando…',
    espera_diag_erro: 'No se pudo ejecutar el diagnóstico',
    espera_previa: 'Quién está en la fila:',
    reativacao_sem_voltar: "sin volver hace {dias} días",
    lembretes_janela_de: 'Enviar desde',
    lembretes_janela_ate: 'hasta',
    lembretes_remover: 'Quitar',
    btn_salvar_agenda: 'Guardar agenda',
    agenda_testar: 'Probar conexión',
    agenda_testando: 'Probando...',
    agenda_toast_salvo: '¡Configuración de agenda guardada!',
    confirmar_desativar_integracao: '¿Desactivar esta integración? La concierge dejará de consultar horarios y agendar con ella. Las credenciales guardadas se eliminarán.',
    agenda_toast_conexao_ok: '¡Conexión con el calendario OK!',
    agenda_toast_conexao_erro: 'Error de conexión con el calendario',
  },

  conversas: {
    titulo: 'Conversaciones',
    subtitulo: 'Historial de conversaciones y respuestas automáticas vía IA. La IA responde independientemente de esta pantalla — solo necesita que la configuración esté guardada y activada para cada instancia.',
    btn_debug: '🔍 Debug',
    btn_atualizar: 'Actualizar',
    debug_titulo: 'Diagnóstico del Webhook',
    debug_config_titulo: 'Configuración actual en Evolution',
    debug_config_select: 'Selecciona una pestaña de instancia para ver la config de su webhook.',
    debug_ultimos: 'Últimos {n} webhooks recibidos (más reciente primero)',
    debug_sem_webhook: '⚠ Ningún webhook recibido desde el último reinicio del servidor. Si acabas de enviar un mensaje y nada aparece aquí, la Evolution NO está pudiendo entregar los webhooks al backend (URL incorrecta, instancia sin webhook configurado, o error de red).',
    abas_todas: 'Todas',
    todas_instancias: 'Todas las instancias',
    aba_instancia: 'Instancia: {nome}',
    busca_placeholder: 'Buscar nombre o teléfono',
    sem_conversas: 'Ninguna conversación aún.',
    webhook_aviso_titulo: '⚠ ¿Sin mensajes en esta instancia?',
    webhook_aviso_texto: 'El webhook puede no estar configurado en la Evolution API para "{instancia}". Haz clic abajo para registrarlo automáticamente.',
    btn_configurar_webhook: 'Configurar webhook ahora',
    badge_humano: 'Humano',
    badge_ia_ativa: 'IA activa',
    badge_pendente: 'Esperando equipo',
    badge_insatisfeito: 'Cliente insatisfecho',
    badge_followup: 'Seguimiento enviado',
    badge_admin_grupo: 'Admin del grupo',
    badge_ia_no_grupo: 'IA activa en el grupo',
    btn_ativar_ia_grupo: 'Permitir IA en el grupo',
    btn_desativar_ia_grupo: 'Desactivar IA del grupo',
    toast_ia_grupo_ativada: 'IA autorizada a responder en este grupo',
    toast_ia_grupo_desativada: 'IA desactivada en este grupo',
    toast_err_ia_grupo: 'Error al cambiar autorización de IA en el grupo',
    grupo_label: 'Grupo de WhatsApp',
    qualif_todas: 'Todas',
    qualif_agendados: 'Agendados',
    qualif_aguardando: 'Pendientes',
    selecione_conversa: 'Selecciona una conversación',
    btn_voltar: '← Volver',
    btn_assumir: 'Asumir',
    btn_retomar_ia: 'Reanudar IA',
    sem_mensagens: 'Sin mensajes aún',
    placeholder_mensagem: 'Escribe un mensaje... (Enter envía, Shift+Enter nueva línea)',
    placeholder_legenda: 'Leyenda (opcional)...',
    btn_enviar: 'Enviar',
    btn_enviando: 'Enviando...',
    aviso_pausar: 'Al enviar manualmente, la IA se pausa en esa conversación por el tiempo configurado.',
    toast_midia_erro: 'No se pudo cargar el archivo multimedia',
    toast_midia_expirada: 'Archivo no disponible — los archivos de WhatsApp expiran después de algunos días',
    toast_erro_conversas: 'Error al cargar conversaciones',
    toast_erro_msgs: 'Error al cargar mensajes',
    toast_pausada: 'IA pausada por {horas}h',
    toast_retomada: 'IA reanudada',
    toast_err_pausar: 'Error al pausar IA',
    toast_err_retomar: 'Error al reanudar IA',
    btn_reativar_ia: 'Reactivar IA',
    toast_reativada: 'IA reactivada en esta conversación',
    toast_err_reativar: 'Error al reactivar IA',
    toast_err_enviar: 'Error al enviar',
    toast_webhook_ok: 'Webhook configurado: {url}',
    toast_webhook_err: 'Error al configurar webhook',
    anexo_baixar: 'Descargar',
    anexo_carregando: 'Cargando...',
    audio_ouvir: 'Escuchar mensaje de voz',
    arquivo_grande: 'Archivo demasiado grande (máx 16 MB)',
  },

  perfil: {
    titulo: 'Perfil de empresa',
    subtitulo: 'Personaliza la identidad visual y consulta tu suscripción.',
    carregando: 'Cargando...',
    sua_assinatura: 'Tu suscripción',
    plano_label: 'Plan {nome}',
    periodo_anual: 'Anual',
    periodo_mensal: 'Mensual',
    vencimento: 'Vencimiento',
    dias_restantes: '{n} días restantes',
    status_vencida: '⚠️ Suscripción vencida — renueva para continuar',
    status_vencendo: '⚠️ Vence pronto — considera renovar',
    preview_titulo: 'Vista previa del panel',
    preview_empresa: 'Tu empresa',
    preview_segmento: 'Segmento',
    stat_plano: 'Plan',
    stat_status: 'Estado',
    stat_campanhas: 'Campañas',
    stat_contatos: 'Contactos',
    form_titulo: 'Información de la empresa',
    label_nome_empresa: 'Nombre de la empresa',
    placeholder_nome_empresa: 'Ej: Clínica Bienestar',
    label_segmento: 'Segmento',
    segmento_placeholder: 'Selecciona...',
    label_logo_url: 'URL del logo',
    placeholder_logo_url: 'https://tu-empresa.com/logo.png',
    logo_help: 'Usa una URL pública de la imagen',
    label_cor: 'Color principal del panel',
    btn_salvar: 'Guardar perfil',
    btn_salvando: 'Guardando...',
    toast_salvo: '¡Perfil actualizado!',
    toast_erro: 'Error al guardar',
    seg_clinica: 'Clínica / Salud',
    seg_imobiliaria: 'Inmobiliaria',
    seg_educacao: 'Educación',
    seg_varejo: 'Retail / E-commerce',
    seg_restaurante: 'Restaurante / Alimentación',
    seg_beleza: 'Belleza / Estética',
    seg_advocacia: 'Abogacía / Jurídico',
    seg_contabilidade: 'Contabilidad / Financiero',
    seg_tecnologia: 'Tecnología',
    seg_outro: 'Otro',
  },
};

export default es;
